import _extends from "@babel/runtime/helpers/extends";
export default (function (baseStyles) {
  return _extends({}, baseStyles, {
    whiteSpace: "break-spaces",
    display: "inline"
  });
});